import { ORDERED_WEEKDAY_KEYS } from '@/constants/dates';

/**
 * Uppercase weekday names for the form's `selectedWeekDays` field.
 * Matches the format expected by `convertFormDataToHoursOfOperation`.
 * Derived from `ORDERED_WEEKDAY_KEYS` so order always matches the API.
 */
export const EDIT_PROVIDER_SCHEDULE_DAY_NAMES = Object.freeze(
  ORDERED_WEEKDAY_KEYS.map((key) => key.toUpperCase()),
);
